


















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {

    // 处理数据
    this.data = JSON.parse(JSON.stringify(this.detail));
  }
  private data: any = {};
  private mounted() {
    this.data = JSON.parse(JSON.stringify(this.detail));
  }
}
